<template>
  <div class="tv">
    <div>
      <span class="tv__title">Saved Views</span>
    </div>
    <div>
      <div class="tv__tabs">
        <div
          class="tv__tab"
          :class="{ tv__tab_active: selectedPermission === permissions.global }"
          @click="changeTab(permissions.global)"
        >
          Global
        </div>
        <div
          class="tv__tab"
          :class="{
            tv__tab_active: selectedPermission === permissions.personal,
          }"
          @click="changeTab(permissions.personal)"
        >
          Personal
        </div>
        <div
          class="tv__tab"
          :class="{
            tv__tab_active: selectedPermission === permissions.project,
          }"
          @click="changeTab(permissions.project)"
        >
          Project
        </div>
      </div>
      <div id="table-wrapper">
        <table id="table">
          <template v-if="isEditing">
            <tr>
              <th>View Name</th>
              <th>Description</th>
              <th>Type</th>
            </tr>
            <tr>
              <td>
                <input type="text"
                      v-model="form.name"
                      placeholder="Enter view name"
                      class="edit_input">
              </td>
              <td>
                <input type="text"
                  v-model="form.description"
                  placeholder="Enter description"
                  class="edit_input"/>
              </td>
              <td class="td_type_select">
                <base-select
                  :options="form.typeOptions"
                  v-model="selectedPermission"
                  :propListStyle="{cursor: 'pointer'}"
                  showTopBorder
                  :placeholder="'Select'"
                  :borderLess="true"
                  :selectStyle="{width: '100%'}"
                />
              </td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <th>View Name</th>
              <th>Description</th>
              <th></th>
            </tr>
            <tr v-for="(view, i) in views[selectedPermission]" :key="i"
             :class="{ selected: view.id === currentTableViewHash }"
            >
              <td>
                <router-link class="tv__name_link"
                 :class="{ tv__name_link_selected: view.id === currentTableViewHash }"
                 :to="{ name: $route.name, params: { id: view.id }}" replace>
                  <span @click="$emit('select', view.id)">{{ `${view.name}${view.id === currentTableViewHash ? ' (selected)' : ''}`}}</span>
                </router-link>
                <!-- <input
                  type="text"
                  :value="view.name"
                  @click="$emit('select', view.id)"
                  readonly
                  class="tv__link read"
                  :class="{ selected: view.id === currentTableViewHash }"
                /> -->
              </td>
              <td>
                <input
                  type="text"
                  :value="view.description"
                  readonly
                  class="read tv__saved_desc"
                  v-tooltip.top-start="{
                    content: view.description,
                    ...tooltipOptions,
                  }"
                />
              </td>
              <td class="tv__edit_menu">
                <base-select
                  v-if="view.editOptions.length"
                  :isHideArrow="true"
                  :options="view.editOptions"
                  :propListStyle="{cursor: 'pointer'}"
                  @change="editView($event, view)"
                  alignLeft
                  :borderLess="true"
                  :placeholderIcon="'dotsVertical'"
                  :placeholderStyle="{
                    'font-size': '20px',
                    'color': '#011627',
                    'padding': '0'
                  }"
                />
              </td>
            </tr>
            <tr v-if="!selectedView && (isUserSuperAdmin || selectedPermission !== 'global')" class="tv__row_save_current">
              <td class="td_add_current" @click="isEditing = true" colspan="3">
                <span class="tv__save_current"
                  >Save Current View</span
                >
              </td>
            </tr>
          </template>
        </table>
      </div>
      <div class="tv__controls">
        <button v-if="isEditing"
          class="tv__button tv__button_submit"
          @click="$emit('apply', { details, tableViewId: currentTableViewHash, closeModal: false })"
        >
          Apply
        </button>
        <button class="tv__button tv__button_cancel" @click="isEditing ? cancelEdit() : close()">
          {{ isEditing ? 'Cancel' : 'Close' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import BaseModalMixins from '@/common/BaseModalMixins'
import { cloneDeep } from 'lodash'

export default {
  name: 'CreateTableView',
  mixins: [BaseModalMixins],
  props: {
    views: Object,
    clientId: String,
    userId: String,
    currentTableViewHash: String
  },
  created () {
    this.resetForm()
    this.storedTableViewHash = this.currentTableViewHash
  },
  mounted () {
    const selectedView =
      !!document.getElementsByClassName('selected').length &&
      document.getElementsByClassName('selected')[0]
    if (selectedView) {
      selectedView.scrollIntoView({ block: 'center' })
    } else {
      document.getElementsByClassName('tv__row_save_current')[0].scrollIntoView()
    }
  },
  data () {
    return {
      selectedPermission: 'project',
      selectedView: null,
      storedTableViewHash: null,
      isEditing: false,
      form: {
        name: null,
        description: null
      },
      permissions: {
        personal: 'personal',
        project: 'project',
        global: 'global'
      },
      tooltipOptions: {
        delay: { show: 100, hide: 100 },
        classes: 'rfx-tooltip-arrow saved-view-tooltip'
      },
      typeOptions: [
        {
          label: 'Project',
          value: 'project'
        },
        {
          label: 'Personal',
          value: 'personal'
        },
        {
          label: 'Global',
          value: 'global'
        }
      ]
    }
  },
  watch: {
    views: {
      handler (newData) {
        this.resetForm()
      },
      deep: true
    }
  },
  computed: {
    details () {
      return {
        name: this.form.name,
        description: this.form.description,
        clientId:
          this.selectedPermission !== this.permissions.global
            ? this.clientId
            : null,
        userId:
          this.selectedPermission === this.permissions.personal
            ? this.userId
            : null
      }
    },
    isUserSuperAdmin () {
      return this.userRoles.includes('admin')
    },
  },
  methods: {
    close () {
      this.$emit('close')
    },
    applyEdit (view) {
      this.$emit('apply', {
        details: this.details,
        tableViewId: view.id,
        closeModal: false
      })
    },
    cancelEdit () {
      this.currentTableViewHash = this.storedTableViewHash
      this.form.name = null
      this.form.description = null
      this.form.typeOptions = this.typeOptions
      this.isEditing = false
    },
    editView (event, view) {
      switch (event) {
        case 'delete':
          this.$emit('delete', { tableViewId: view.id, closeModal: false })
          break
        case 'edit':
          this.currentTableViewHash = view.id
          this.form.name = view.name
          this.form.description = view.description
          this.form.typeOptions = view.typeOptions
          this.isEditing = true
          break
      }
    },
    changeTab (permission) {
      if (!this.isEditing) {
        this.selectedPermission = permission
      }
    },
    resetForm () {
      this.isEditing = false
      this.selectedPermission = 'global'
      this.selectedView = null
      this.form.name = null
      this.form.description = null
      this.form.typeOptions = this.typeOptions
      this.setSelectedData()
      this.setViewEditOpts()
    },
    setSelectedData () {
      let selectedPermission = 'global'
      let selectedView = null
      let name = null
      let description = null
      for (const category in this.views) {
        const view = this.views[category].find(
          (view) => view.id === this.currentTableViewHash
        )
        if (view) {
          selectedPermission = category
          selectedView = view
          name = view.name
          description = view.description
          break
        }
      }
      this.selectedPermission = selectedPermission
      this.selectedView = selectedView
      this.form.name = name
      this.form.description = description
      this.form.typeOptions = this.typeOptions
    },
    setViewEditOpts () {
      for (const category in this.views) {
        let typeOptions = []
        if (category === 'personal') {
          typeOptions = this.typeOptions.slice(0, 2)
        } else if (category === 'project') {
          typeOptions = [ this.typeOptions[0] ]
        } else if (category === 'global') {
          typeOptions = [ this.typeOptions[2] ]
        }
        this.views[category].forEach((view) => {
          view.typeOptions = typeOptions
          let editOptions = []
          if ((this.isUserSuperAdmin || category !== 'global') && !editOptions.find(opt => opt.value === 'edit')) {
            editOptions.push({
              label: 'Edit',
              value: 'edit'
            })
          }
          if ((this.isUserSuperAdmin || category === 'personal') && !editOptions.find(opt => opt.value === 'delete')) {
            editOptions.push({
              label: 'Delete',
              value: 'delete'
            })
          }
          view.editOptions = editOptions
        })
      }
    }
  }
}
</script>

<style lang="scss">
  .saved-view-tooltip {
    max-width: 300px !important;
  }
</style>
<style scoped lang="scss">

.selected {
  background-color: $rfx-light-steel;
}

textarea {
  resize: none;
}

.edit_input {
  outline: none;
  border: none;
  width: 100%;
}

.read {
  border: none;
  cursor: default;
}
.read:focus {
  outline: none;
}

#table-wrapper {
  margin-top: 30px;
  height: 300px;
  overflow-y: scroll;
}

table {
  border-collapse: collapse;
  width: 100%;
  border: 1px solid $rfx-light-steel;
  border-radius: 4px;
}

table tr {
  border-bottom: 1px solid $rfx-light-steel;
  &:last-child {
    border-bottom: 0;
  }
}

table tr td {
  padding: 0 16px;
  border-bottom: 1px solid $rfx-light-steel;
  &:nth-child(2) {
    border-left: 1px solid $rfx-light-steel;
  }
  &.td_type_select {
    border-left: 1px solid $rfx-light-steel;
  }
  &.td_add_current {
    text-align: center;
    font-weight: 600;
    text-transform: uppercase;
    font-size: 10px;
    cursor: pointer;
  }
  height: 40px;
}

th {
  background: $rfx-light-steel;
  position: sticky;
  top: 0;
  z-index: 1;
  padding: 10px 16px;
}

.tv {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding: 40px;

  &__title {
    display: block;
    text-align: center;
    font-size: 32px;
    font-weight: 500;
    margin-bottom: 30px;
  }
  &__saved_desc {
    width: 95%;
    text-overflow: ellipsis;
    background: transparent;
  }

  &__edit_menu {
    width: fit-content;
  }

  &__name_link {
    color: $rfx-bright-blue;
    text-decoration: none;
  }

  &__name_link_selected {
    font-weight: bold;
  }

  &__input {
    display: flex;
    flex-direction: column;
    position: relative;
    margin-top: 30px;

    &_invalid[type="text"] {
      border: 1px solid $rfx-red;
      border-radius: 4px;
    }
  }

  &__label {
    display: block;
    font-weight: 600;
    margin-bottom: 5px;
    color: $rfx-dark-march;
  }

  &__controls {
    display: flex;
    justify-content: flex-end;
    margin-top: 30px;
  }

  &__button {
    width: 100px;
    height: 40px;
    border-radius: 4px;
    font-size: 10px;
    font-weight: 900;
    text-transform: uppercase;
    margin-left: 30px;
    border: none;
    outline: none;
    cursor: pointer;

    &_submit {
      background-color: $rfx-medium-march;
      color: #fff;
    }

    &_cancel {
      color: $rfx-dark-march;
      background-color: #fff;
    }
  }

  &__buttons_wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__link {
    color: $rfx-bright-blue;
    cursor: pointer;
  }

  &__tabs {
    display: grid;
    margin-right: 20%;
    grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));

    border: 1px solid $rfx-light-steel;
    border-radius: 4px;
    height: 40px;
  }

  &__tab {
    font-weight: 500;
    outline: none;
    font-size: 10px;
    border: none;
    color: $rfx-dark-march;
    margin: 0;
    cursor: pointer;
    transition: box-shadow 0.3s;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #fff;
    text-decoration: none;

    &:hover {
      box-shadow: 0 0 11px 5px rgba(33, 33, 33, 0.2);
    }

    &_center {
      border-left: 1px solid $rfx-light-steel;
      border-right: 1px solid $rfx-light-steel;
    }

    &_active {
      background-color: rgba(1, 22, 39, 0.1);
      opacity: 1;

      &:hover {
        box-shadow: none;
      }
    }
    &_disabled {
      pointer-events: none;
      cursor: default;
    }
  }
}
</style>
